<template>
  <div ref="phaserContainer" class="phaser-container"></div>
</template>

<script setup>
import { inject, onMounted, onUnmounted, ref } from 'vue';
import { GameEvents } from '../lib/GameEvents';

const game = inject('game');
const phaserContainer = ref(null);

onMounted(() => {
  game.emit(GameEvents.PHASER_CANVAS_READY, {
    element: phaserContainer.value,
    width: window.innerWidth,
    height: window.innerHeight,
  });
});

onUnmounted(() => {
  game.emit(GameEvents.PHASER_CANVAS_DESTROYED);
});
</script>

<style scoped>
.phaser-container {
  background: radial-gradient(ellipse at center, var(--hw-bg-forest-light) 0%, var(--hw-bg-forest) 100%);
}
</style>
